import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { regionais } from '../../../constants/region.constant';
import { especialidadesEAreasDeAtuacao } from '../../../models/index';
import { ProductService } from '../../../services/product-service/product.service';

import { FormControl,Validators} from '@angular/forms';
import { UtilService } from 'src/app/services/util-service/util.service';
// import { Router } from '@angular/router';
// import { SettingsService } from '../../../services/setting-service/setting.service';

@Component({
  selector: 'app-product-edit',
  standalone: false,
  templateUrl: './product-edit.html',
  styleUrl: './product-edit.scss',
})
export class ProductEdit implements OnInit, OnDestroy {
  public kit: any = {};
  public edit: any={};
  public regions:any = regionais;
  public regionOptions = regionais.map((r: string) => ({ value: r, description: r }));
  public specialties:any = especialidadesEAreasDeAtuacao;
  loading:boolean = false;
  display: FormControl = new FormControl("", Validators.required);
  file_store: any = [];
  file_list: Array<string> = [];
  isDragging = false;

  readonly dialogRef = inject(MatDialogRef<ProductEdit>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: {kit: any},
    @Inject(ProductService) private productService: ProductService,
    @Inject(UtilService) private utilService: UtilService,
    // private router: Router,
    // private settingsService: SettingsService
  ) {
    this.kit = data.kit;
    this.edit = {...this.kit};
    this.edit.descricao_resumo = this.stripHtml(this.edit.descricao_resumo);
    this.edit.descricao = this.stripHtml(this.edit.descricao);
    this.display.patchValue(this.kit.imagem);
   }

     ngOnInit(): void {
      console.log(this.specialties)
     }

   ngOnDestroy(): void {}
  stripHtml(html: string): string {
    if (!html) return '';
    let text = html.replace(/<br\s*\/?>/gi, '\n');
    text = text.replace(/<\/p>\s*<p[^>]*>/gi, '\n');
    text = text.replace(/<[^>]+>/g, '');
    return text.trim();
  }

  getSpecialtyDescriptions(values: string[]): string {
    if (!values?.length) return '';
    return values
      .map(v => this.specialties.find((s: any) => s.value === v)?.description || v)
      .join(', ');
  }

  getSpecialtyDescriptionsArray(values: string[]): string[] {
    if (!values?.length) return [];
    return values
      .map(v => this.specialties.find((s: any) => s.value === v)?.description || v)
      .filter(desc => desc); // Remove valores vazios
  }

   setValue(ev:any){
    return ev.target.value;
   }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer?.files.length) {
      this.handleFileInputChange(event.dataTransfer.files);
    }
  }

  handleFileInputChange(file: FileList): void {    
    this.file_store = file;
    this.file_list = [];

    if (file && file.length > 0) {
      const f = file[0];
      const countText = file.length > 1 ? ` (+${file.length - 1} files)` : "";
      this.display.patchValue(`${f.name}${countText}`);

      this.previewImage(f);
      for (let i = 0; i < file.length; i++) {
        this.file_list.push(file[i].name);
      }
      console.log('Arquivo(s) processado(s):', this.file_list);
    } else {
      this.display.patchValue("");
      // Não limpa edit.imagem aqui para manter imagem existente se houver
      console.log('Nenhum arquivo selecionado');
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload =  () => {
      this.edit.imagem = reader.result;

    };
     reader.readAsDataURL(file)
  }


   async save(){
     this.loading = true;
      try {
        
        let payload = { ...this.edit };

        // Se há um novo arquivo selecionado, inclui no payload
        if (this.file_store?.length) {
          console.log('Processando novo arquivo...');
          const file: File = this.file_store[0];
          const base64 = await this.utilService.convertFileToBase64(file);
          payload.file = {
            base64: base64,
            filename: file.name,
            mimetype: file.type
          };
          this.edit.imagem = base64;
        } else if (!this.edit.imagem) {
          // Se não há arquivo novo e não há imagem existente, exige arquivo
          console.log('Nenhum arquivo novo e nenhuma imagem existente - lançando erro');
          throw new Error('Nenhum arquivo selecionado');
        } else {
          console.log('Usando imagem existente, sem novo arquivo');
        }

        console.log('Enviando payload para API...');
        await this.productService.updateKit(payload);
        this.loading = false;
        this.dialogRef.close(this.edit);
    } catch (error) {
      this.loading = false;
      console.error('Erro no save():', error);
      throw error; // Propaga o erro para tratamento adequado
    }

   }

   goToProducts() {
      this.dialogRef.close();
   }
}
